$shm_hitalama_map_widget_view_dom $mol_view
	dom_name \div
	content null
